import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import './styles.css';

const rootEl = document.getElementById('root')!;
const tree = (
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Prerendered public pages (scripts/prerender.ts) ship server-rendered markup
// inside #root → hydrate it. Portal/admin and any non-prerendered route ship an
// empty #root → mount a fresh client tree exactly as before.
if (rootEl.firstElementChild) {
  ReactDOM.hydrateRoot(rootEl, tree);
} else {
  ReactDOM.createRoot(rootEl).render(tree);
}
